import { Routes } from '@angular/router';

export const settlementsRoutes: Routes = [
    {
        path: 'dashboard',
        data: { breadcrumb: 'Dashboard' },
        loadComponent: () =>
            import('./views/dashboard/dashboard.component').then(
                (m) => m.DashboardComponent,
            ),
    },
    {
        path: 'periods',
        loadChildren: () =>
            import('./periods/periods.routes').then((m) => m.periodsRoutes),
    },
    {
        path: 'waybills',
        loadChildren: () =>
            import('./waybills/waybills.routes').then((m) => m.waybillsRoutes),
    },
    {
        path: 'config/consumable-types',
        loadChildren: () =>
            import('./consumable-types/consumable-types.routes').then(
                (m) => m.consumableTypesRoutes,
            ),
    },
    {
        path: 'consumables',
        loadChildren: () =>
            import('./consumables/consumables.routes').then(
                (m) => m.consumablesRoutes,
            ),
    },
    {
        path: 'consumable-recurrences',
        loadChildren: () =>
            import('./consumable-recurrences/consumable-recurrences.routes').then(
                (m) => m.consumableRecurrencesRoutes,
            ),
    },
    {
        // F13 — un solo destino reemplaza a `rate-cards` y `tariff-circuits` (borradas en B7).
        path: 'rate-agreements',
        loadChildren: () =>
            import('./rate-agreements/rate-agreements.routes').then(
                (m) => m.rateAgreementsRoutes,
            ),
    },
    // `fuel-bands` fue retirada del menú y de las rutas (F1, req. 07, opción b): la reemplazan
    // `fuel-providers` y `fuel-prices`. El código queda en el árbol, sin ruta que lo alcance.
    {
        path: 'fuel-providers',
        loadChildren: () =>
            import('./fuel-providers/fuel-providers.routes').then(
                (m) => m.fuelProvidersRoutes,
            ),
    },
    {
        path: 'fuel-prices',
        loadChildren: () =>
            import('./fuel-prices/fuel-prices.routes').then(
                (m) => m.fuelPricesRoutes,
            ),
    },
    {
        path: 'advances',
        loadChildren: () =>
            import('./advances/advances.routes').then((m) => m.advancesRoutes),
    },
    {
        path: 'customers',
        loadChildren: () =>
            import('./customers/customers.routes').then(
                (m) => m.customersRoutes,
            ),
    },
    {
        path: 'settlements',
        loadChildren: () =>
            import('./settlements/settlements.routes').then(
                (m) => m.settlementsRoutes,
            ),
    },
    {
        path: 'contracts',
        loadChildren: () =>
            import('./commercial-contracts/commercial-contracts.routes').then(
                (m) => m.commercialContractsRoutes,
            ),
    },
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
    },
];
